import { CreditCard } from 'lucide-react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { OUT_OF_TOKENS_MESSAGE } from '@/lib/ai'
import { useBilling } from './billingContext'

/**
 * What every AI feature shows when a run is refused for want of tokens
 * (HTTP 402, `AI_INSUFFICIENT_TOKENS`): the API's message, in tokens, and a
 * way to buy more. The button navigates inside the app, so a half-filled
 * form behind it is not lost.
 */
export const BuyTokensButton = ({ className, size = 'sm' }: { className?: string; size?: 'sm' | 'default' }) => {
    const { openPricing } = useBilling()
    return (
        <Button type='button' size={size} className={className} onClick={() => openPricing('credits')}>
            <CreditCard className='h-4 w-4' /> Buy more tokens
        </Button>
    )
}

/** The message with the button under it, as an alert box. */
export const OutOfTokensAlert = ({ message, className }: { message?: string | null; className?: string }) => (
    <Alert className={cn('border-red-300 bg-red-50', className)}>
        <AlertDescription className='flex flex-col items-start gap-2'>
            <span>{message || OUT_OF_TOKENS_MESSAGE}</span>
            <BuyTokensButton />
        </AlertDescription>
    </Alert>
)

/** The message with the button beside it, small enough for a one-line hint. */
export const OutOfTokensHint = ({ message }: { message?: string | null }) => (
    <span className='flex flex-wrap items-center gap-x-2 gap-y-1'>
        <span>{message || OUT_OF_TOKENS_MESSAGE}</span>
        <BuyTokensButton className='h-7 px-2.5 text-xs' />
    </span>
)
